import { useLocation } from 'react-router-dom';
import { FORM_ROLES } from '../constants/roles';
import { useOnBehalfSubmitter } from '../container/onBehalfContext';

// creator | initiator | submitter | undefined
// Also refers to require_for (initiator | submitter)
export const useUserFormRole = () => {
  const { pathname } = useLocation();
  // A form being submitted on someone's behalf from the Submissions folder is
  // filled in inside a modal on that page, so the route says nothing about the role.
  const onBehalfOf = useOnBehalfSubmitter();
  let role = undefined;
  if (onBehalfOf) {
    role = FORM_ROLES.FORM_SUBMITTER;
  } else if (pathname.includes('/initialization-form/')) {
    role = FORM_ROLES.FORM_INITIATOR;
  } else if (pathname.includes('/form-builder/')) {
    role = FORM_ROLES.FORM_CREATOR;
  } else if (pathname.includes('/form-view/')) {
    role = FORM_ROLES.FORM_SUBMITTER;
  } else if (pathname.includes('/form-view-contact/')) {
    role = FORM_ROLES.FORM_SUBMITTER;
  } else if (pathname.includes('/form-view-unregister/')) {
    role = FORM_ROLES.FORM_SUBMITTER;
  }

  return role;
};
